import { useEffect, useRef } from "react";
import "./paymentCheque.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import { getPaymentDetails } from "../redux/main-reducer";
import { NavLink } from "react-router-dom";

function PaymentCheque() {
  const peymentDetails = useSelector(getPaymentDetails);
  const searchParams = new URLSearchParams(window.location.search);
  const isInvType = searchParams.get("inv_type") === "4";

  const redirectTimeoutRef = useRef(null);

  // Автоматический редирект через 5 секунд
  useEffect(() => {
    if (isInvType) {
      redirectTimeoutRef.current = setTimeout(() => {
        window.location.replace(peymentDetails?.success_url);
      }, 180000);
    }

    // Очистка таймера при размонтировании
    return () => clearTimeout(redirectTimeoutRef.current);
  }, []);

  const downloadPDF = () => {
    const input = document.getElementById("cheque-content");
    html2canvas(input, {
      scale: 2,
      useCORS: true, // если картинки из CDN
      windowWidth: input.scrollWidth, // фикс для мобил
      windowHeight: input.scrollHeight, // фикс для мобил
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      const pageHeight = pdf.internal.pageSize.getHeight();
      let heightLeft = pdfHeight;
      let position = 0;

      // первая страница
      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, pdfHeight);
      heightLeft -= pageHeight;

      // остальные страницы
      while (heightLeft > 0) {
        position -= pageHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, pdfHeight);
        heightLeft -= pageHeight;
      }

      pdf.save("payment.pdf");
    });
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "flex-start",
        gap: "20px",
        minHeight: "100vh",
        backgroundColor: "#F7F7F7",
        padding: "0 18px",
      }}
    >
      <div className="paymentCheque paymentCheque_container">
        <div className="paymentCheque_content" id="cheque-content">
          <div className="paymentCheque_logo">
            <img
              className="paymentInfo-details-list-left-block__logo"
              src={peymentDetails?.image_url || ""}
              alt="logo"
            />
          </div>
          <div className="paymentCheque_price">
            {peymentDetails?.total_amount && peymentDetails?.total_amount !== 0
              ? peymentDetails?.total_amount
              : peymentDetails?.amount}
          </div>
          <div className="paymentCheque_status">Успешно</div>
          <div className="paymentCheque_title-block">
            <div className="paymentCheque_title">Детали платежа</div>
          </div>
          <div className="paymentCheque_payment-info">
            <div className="paymentCheque_row">
              <div className="paymentCheque_row_header">Номер счета</div>
              <div className="paymentCheque_row_dots"></div>
              <div className="paymentCheque_row_value">
                {peymentDetails?.invoice_id}
              </div>
            </div>
            <div className="paymentCheque_row">
              <div className="paymentCheque_row_header">Организация</div>
              <div className="paymentCheque_row_dots"></div>
              <div className="paymentCheque_row_value">
                {peymentDetails?.merchant_org_name}
              </div>
            </div>
            <div className="paymentCheque_row">
              <div className="paymentCheque_row_header">Название</div>
              <div className="paymentCheque_row_dots"></div>
              <div className="paymentCheque_row_value">
                {peymentDetails?.product_name}
              </div>
            </div>
            <div className="paymentCheque_row">
              <div className="paymentCheque_row_header">Количество</div>
              <div className="paymentCheque_row_dots"></div>
              <div className="paymentCheque_row_value">
                {peymentDetails?.count}
              </div>
            </div>
            <div className="paymentCheque_row">
              <div className="paymentCheque_row_header">Сумма</div>
              <div className="paymentCheque_row_dots"></div>
              <div className="paymentCheque_row_value paymentCheque_row_value-wrap">
                {peymentDetails?.amount}
              </div>
            </div>
            <div className="paymentCheque_row">
              <div className="paymentCheque_row_header">Дата</div>
              <div className="paymentCheque_row_dots"></div>
              <div className="paymentCheque_row_value">
                {peymentDetails?.date}
              </div>
            </div>
            <div className="paymentCheque_row">
              <div className="paymentCheque_row_header">Комиссия</div>
              <div className="paymentCheque_row_dots"></div>
              <div className="paymentCheque_row_value">
                {peymentDetails?.commission}
              </div>
            </div>
            <div className="paymentCheque_row">
              <div className="paymentCheque_row_header">Общая сумма</div>
              <div className="paymentCheque_row_dots"></div>
              <div className="paymentCheque_row_value">
                {peymentDetails?.total_amount}
              </div>
            </div>
          </div>
          <div className="paymentCheque_title-block">
            <div className="paymentCheque_title">Данные плательщика</div>
          </div>
          <div className="paymentCheque_payment-info _border">
            <div className="paymentCheque_row">
              <div className="paymentCheque_row_header">Имя</div>
              <div className="paymentCheque_row_dots"></div>
              <div className="paymentCheque_row_value">
                {peymentDetails?.sender}
              </div>
            </div>
            <div className="paymentCheque_row">
              <div className="paymentCheque_row_header">Номер карты</div>
              <div className="paymentCheque_row_dots"></div>
              <div className="paymentCheque_row_value">
                {peymentDetails?.sender_card}
              </div>
            </div>
          </div>
        </div>
        <div className="paymentCheque_button-block">
          {isInvType && (
            <button
              type="button"
              className="comeback-button"
              onClick={() => {
                clearTimeout(redirectTimeoutRef.current);
                window.location.replace(`${peymentDetails?.success_url}`);
              }}
            >
              Вернуться в магазин
            </button>
          )}
          <button onClick={downloadPDF} className="download-button">
            Сохранить
          </button>
          {peymentDetails?.fiscal_url && peymentDetails?.is_finished && (
            <NavLink
              target={"_blank"}
              className="download-button _text"
              to={`${peymentDetails?.fiscal_url}`}
            >
              Фискальный URL
            </NavLink>
          )}
        </div>
      </div>
    </div>
  );
}

export default PaymentCheque;
